import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

const useWidth = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints?.between('md', 'lg'));
  const controlSize = isSmallScreen ? 'small' : isMediumScreen ? 'medium' : 'large';

  return controlSize;
};

export default useWidth;
